import { faExclamationCircle } from "@fullscript/pro-regular-svg-icons";
import { Trans, useTranslation } from "react-i18next";

import { FloatingLabelInput } from "@aviary";
import { e2eAttributes } from "@shared/e2eAttributes";
import { useSharedGlobalConfig } from "@shared/hooks/useSharedGlobalConfig/useSharedGlobalConfig";
import { l } from "@shared/locales/i18n";

import { IconWrapper } from "../../IconWrapper/IconWrapper";
import * as styles from "../fields.styles";
import type { FieldProps } from "../types";

import RoutingNumberSVGComponent from "./RoutingNumber";

const RoutingNumberField = ({ value, errors, onChange }: FieldProps) => {
  const { t } = useTranslation();
  const { isUS } = useSharedGlobalConfig();

  const labelText = isUS
    ? t(l.sharedSettings.tax.bankInfo.routingNumber)
    : t(l.sharedSettings.tax.bankInfo.transitAndInstitutionNumber);

  const tooltipText = isUS ? (
    <Trans i18nKey={l.sharedSettings.tax.bankInfo.routingNumberTooltip}>
      Your <strong>routing number</strong> is typically found on checks provided by your bank.
    </Trans>
  ) : (
    <Trans i18nKey={l.sharedSettings.tax.bankInfo.transitAndInstitutionNumberToolTip}>
      Your <strong>Transit/branch and institution number</strong> are typically found on checks
      provided by your bank.
    </Trans>
  );

  return (
    <IconWrapper
      icon={faExclamationCircle}
      tooltipMessage={
        <>
          <RoutingNumberSVGComponent css={styles.tooltipSvg} />
          {tooltipText}
        </>
      }
      tooltipPosition="bottom-end"
    >
      <FloatingLabelInput
        type="text"
        id="routingNumber"
        data-testid="routing-number-input"
        label={labelText}
        value={value || ""}
        required
        minLength={isUS ? 9 : 8}
        maxLength={isUS ? 9 : 8}
        handleChange={onChange}
        errors={errors}
        data-e2e={e2eAttributes.paymentSettings.routingNumber}
      />
    </IconWrapper>
  );
};

export { RoutingNumberField };
